// extracted by mini-css-extract-plugin
export var choosenRole = "ChoosenRole-module--choosenRole--PA4fB";
export var wrapper = "ChoosenRole-module--wrapper--q8sVy";